export default __webpack_public_path__ + "static/media/INJ.8876f6b4.png";